import { ElementRef } from '@angular/core';
import SignaturePad from '../sigpad/signature_pad';
import { resizeCanvas } from '../sigpad/sigpad_util';

/**
 *
 * @param pad
 * @param options
 * @returns
 */
export function updateCanvasSize(
  pad: ElementRef,
  options: any = {}
): SignaturePad | null {
  if (pad) {
    const signPad = new SignaturePad(pad.nativeElement, options);
    resizeCanvas(pad.nativeElement, signPad);
    return signPad;
  }
  return null;
}
